import strings from '../../strings/strings.json'

interface Props {
    data: any,
}
export default function DriveInfoDetails(props: Props) {
    return (
        <div className='flex flex-col px-10'>
            <div className='primary_text_color text-base font-bold'>{strings.public_deviceInfo}</div>
            <div className='flex flex-col mt-10'>
                <div className='w-52 flex justify-between VazirEng'>
                    <span className='secondry_text_color text-xs'>{strings.public_type}:</span>
                    <span className='text-base'>{props.data.type}</span>
                </div>
                <div className='w-52 flex justify-between VazirEng'>
                    <span className='secondry_text_color text-xs'>{strings.public_system}:</span>
                    <span className='text-base'>{props.data.system?props.data.system:'---'}</span>
                </div>
                <div className='w-52 flex justify-between VazirEng'>
                    <span className='secondry_text_color text-xs'>{strings.public_size}:</span>
                    <span className='text-base'>{props.data.size?props.data.size:'---'}</span>
                </div>
                <div className='w-52 flex justify-between VazirEng'>
                    <span className='secondry_text_color text-xs'>{strings.public_path}:</span>
                    <span className='text-base'>{props.data.path?props.data.path:'---'}</span>
                </div>
            </div>
        </div>
    )
}
